// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import folderIcon from "@/assets/icons/folder.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FolderIconProps = Omit<IconProps, "name">;

export function FolderIcon(props: FolderIconProps): React.ReactNode {
  return <Icon name={folderIcon} {...props} />;
}
